import {
  API_EMAIL_CONFIGURATIONS,
  API_EMAIL_CONFIGURATION,
} from "../../../shared/routes/auth.routes";

import { Client } from "../../../core/api-client";

export class EmailConfigurationService {
  getEmailConfigurations(params: any, body: any) {
    return Client.get(API_EMAIL_CONFIGURATIONS, {
      params: { ...params, ...body },
    });
  }

  createEmailConfiguration(body: any) {
    return Client.post(API_EMAIL_CONFIGURATION, body);
  }

  updateEmailConfiguration(id: string, body: any) {
    return Client.put(`${API_EMAIL_CONFIGURATION}/${id}`, body);
  }

  sendTestEmail(id: string, notificationKey: string) {
    return Client.post(
      `${API_EMAIL_CONFIGURATION}/${id}/test-email`,
      { notificationKey }
    );
  }

  deleteEmailConfiguration(id: string) {
    return Client.delete(`${API_EMAIL_CONFIGURATION}/${id}`);
  }
}